import Typography from 'design-system/src/Components/Typography/Typography';
import React, {FC} from 'react';

interface VideoNotFoundProps {
  message: string;
  viewportHeight: number;
}

const VideoNotFound: FC<VideoNotFoundProps> = ({message, viewportHeight}) => {
  const style = {
    width: '100%',
    height: viewportHeight,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  return (
    <div style={style}>
      <Typography variant="h2">{message}</Typography>
    </div>
  );
};

export default VideoNotFound;
